import { createContext, useContext } from "react";
import type { ReactNode } from "react";

const AnalyticsContext = createContext<any>(null);

const AnalyticsProvider = ({
  children,
  analytics,
}: {
  children: ReactNode;
  analytics: any;
}) => {
  return (
    <AnalyticsContext.Provider value={analytics}>
      {children}
    </AnalyticsContext.Provider>
  );
};

export const useAnalyticsContext = () => useContext(AnalyticsContext);

export default AnalyticsProvider;
